/** Digit typed while Alt is held, from a KeyboardEvent.code such as Numpad2. */
export function appendAltNumpadDigit(
  buffer: string,
  code: string,
  altKey: boolean,
): { buffer: string; consumed: boolean } {
  if (!altKey) {
    return { buffer, consumed: false };
  }
  const match = /^Numpad(\d)$/u.exec(code);
  if (match == null) {
    return { buffer, consumed: false };
  }
  return { buffer: `${buffer}${match[1]}`, consumed: true };
}

/**
 * Character a keyboard wedge meant to type with Alt+numpad.
 * 029 is the ISO 15434 group separator. 030 is the record separator.
 * Browsers drop these from text fields, so the scan handler has to insert them.
 */
export function characterForCompletedAltNumpad(buffer: string): string | null {
  if (buffer.trim() === "") {
    return null;
  }
  const code = Number.parseInt(buffer, 10);
  if (code === 29) {
    return "\u001d";
  }
  if (code === 30) {
    return "\u001e";
  }
  return null;
}
